import { createMuiTheme } from "@material-ui/core/styles";
import * as colors from "@material-ui/core/colors";

/* Colors - names from htmlcsscolor.com */
const VM_CobaltColor = "#0D47A1"; // header rows
const VM_RoyalBlueColor = "#5471D2"; // band colors
const VM_HawkesBlueColor = "#CFDBED"; // 20% tint on cobalt; used for bands

export const primaryColor = VM_CobaltColor;

export const blackColor = "#000000";
export const grayColor = "#808080";
export const whiteColor = "#FFFFFF";

export const HL_PrimaryColor = VM_CobaltColor;
export const HL_SecondaryColor = VM_RoyalBlueColor;
export const HL_BandColor = VM_HawkesBlueColor;

export const DM_HintOfGreenColor = "#E1FFD4";
export const DM_PizazzColor = "#EB7B3B";
export const DM_DarkGrayColor = "#A5A5A5";
export const DM_SaffronColor = "#FEBF2C";
export const DM_HavelockBlueColor = "#4673C1";
export const DM_AppleColor = "#72AD4D";
export const DM_MandyColor = "#E25354";
export const DM_TangerineYellowColor = "#FBCA04";
export const DM_BlueRomanceColor = "#CCEECC";

export const DM_ChartColors = [DM_PizazzColor, DM_DarkGrayColor, DM_SaffronColor, DM_HavelockBlueColor, DM_AppleColor];

export const VM_BtnBorderRadius = "4px"; // radius used for TButton
export const VM_DivBorderRadius = 10;

/* Fonts */
export const fontFamily = ["sans-serif"];

/* Dimensions and positioning */
export const indent = 10;
export const finalYearComboBoxWidth = 80;
export const navComboBoxHeight = 32;
export const configDivHeight = 40;

/* Centers a component horizontally. */
export const hCenteredStyle = {
    display: "flex",
    justifyContent: "center",
};

/* Centers a component vertically. */
export const vCenteredStyle = {
    display: "flex",
    alignItems: "center",
};

/* Places components next to each other in a row. */
export const sideBySideStyle = {
    display: "flex",
    flexDirection: "row",
};

export const configLeftDivStyle = {
    alignItems: "center",
    alignContent: "flex-start",
    display: "flex",
    flexDirection: "row",
};

export const resultCenterDiv = {
    bottom: configDivHeight,
    left: 0,
    overflow: "auto",
    position: "absolute",
    right: 0,
    top: navComboBoxHeight,
};

export const configDivStyle = {
    alignItems: "center",
    backgroundColor: "#E8E8E8",
    bottom: 0,
    clear: "both",
    display: "flex",
    flexDirection: "row",
    height: 40,
    justifyContent: "space-between",
    left: 0,
    position: "absolute",
    right: 0,
};

export const finalYearComboBoxStyle = {
    backgroundColor: "white",
    width: finalYearComboBoxWidth,
};

export const helpBtnImgStyle = {
    cursor: "pointer",
    height: "32px",
    width: "32px",
};

const muiTheme = createMuiTheme({
    palette: {
        primary: {
            main: VM_CobaltColor,
            //light: TBGBlue,
            //dark: TBGWhite,
            contrastText: "#FFFFFF",
        },
        secondary: {
            main: colors.orange[500],
            //light: '#ff7961',
            //dark: '#ba000d',
            contrastText: "#FFFFFF",
        },
    },
    appBar: {
        backgroundColor: VM_CobaltColor,
    },
    sideBar: {
        backgroundColor: "#eceff1", //'#F9F9F9'
    },
    content: {
        background: whiteColor, //'#F9F9F9'
    },
    bandColor: {
        backgroundColor: colors.blue[50],
    },
    commandBar: {
        backgroundColor: colors.blue[100],
        color: "#000000",
    },
    errorTitle: {
        margin: "0 0 10px 0",
        fontWeight: "bold",
    },
    errorParagraph: {
        margin: "0 0 10px 0",
    },
    errorBox: {
        background: "#EF9A9A",
        borderRadius: "5px",
        padding: "10px",
        marginBottom: "20px",
    },
});

export default muiTheme;
